function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconClock = function SvgIconClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 26"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 16.085V10.5a.5.5 0 1 1 1 0v5.584a1.5 1.5 0 0 1 0 2.83V20.5a.5.5 0 1 1-1 0v-1.585a1.5 1.5 0 0 1 0-2.83m8.271-7.063L24.5 7.793l-.707-.707.707-.707L26.621 8.5l-.707.707-.707-.707-1.229 1.229A11.5 11.5 0 1 1 15 6.011V4h-1V3h3v1h-1v2.011a11.46 11.46 0 0 1 7.271 3.012ZM15.5 28A10.5 10.5 0 1 0 5 17.5 10.5 10.5 0 0 0 15.5 28m0-10a.5.5 0 1 0-.5-.5.5.5 0 0 0 .5.5",
    style: {
      fill: "#244d5a"
    },
    transform: "translate(-4 -3)"
  }));
};
export default SvgIconClock;